import { Suspense, Key, FC, ReactNode } from 'react';

type KeyCalculatorFunc<IProps> = (props: IProps) => Key;

export function asyncWrapper<IProps>(
    Component: FC<IProps>,
    keyCalculator?: KeyCalculatorFunc<IProps>,
    fallback: ReactNode = <></>
) {
    const suspendedContent = (props: IProps & { key?: Key }) => {
        if (!props.key && keyCalculator) props.key = keyCalculator(props);

        return <Suspense fallback={fallback}>
            <Component {...props} />
        </Suspense>
    };

    return suspendedContent;
};